export default class PartnerDetailsSection {}

PartnerDetailsSection.AreasOfInterest = 'AREAS_OF_INTEREST';
PartnerDetailsSection.About = 'ABOUT';
PartnerDetailsSection.Reviews = 'REVIEWS';
